<!--
Copyright (c) 2026 Wind River Systems, Inc.

The right to copy, distribute, modify, or otherwise make use of this software may be licensed only pursuant to the terms of an applicable Wind River license agreement.
-->
<div class="feedback">
  <div class="heading">Product Feedback</div>

  <form class="form" (ngSubmit)="onSubmit()">
    <div class="instruction">
      Use the survey below to share any of your feedback or suggestions for future feature, BSP, middleware, or other
      types of updates with our product team.
    </div>

    <mat-form-field class="select">
      <mat-select [(ngModel)]="selectedProduct" name="product" (selectionChange)="onSelectProduct($event.value)">
        <mat-option *ngFor="let p of products" [value]="p">
          {{ p.name }}
        </mat-option>
      </mat-select>
      <mat-hint>Select a product</mat-hint>
    </mat-form-field>

    <mat-form-field class="enter" appearance="outline">
      <mat-label>Enter feedback</mat-label>
      <textarea
        matInput
        [(ngModel)]="feedback"
        name="feedback"
        maxlength="5000"
        matTextareaAutosize
        matAutosizeMinRows="5"
        matAutosizeMaxRows="25"
      >
      </textarea>
    </mat-form-field>
    <mat-hint class="counter">{{ 5000 - feedback.length }} characters remaining</mat-hint>

    <div class="instruction">
      Include if related to an existing feature, new feature, or recommendations for future enhancements. For Wind River
      Support assistance or to report any bugs, please open a Support Case.
    </div>
  </form>

  <!-- eslint-disable-next-line @angular-eslint/template/eqeqeq -->
  <button mat-raised-button class="submit" [disabled]="!selectedProduct || feedback.length == 0" (click)="onSubmit()">
    Submit
  </button>
</div>

<ng-template #confirmDialog>
  <h2 matDialogTitle>Thank you</h2>
  <mat-dialog-content>
    <p>Your feedback had been submitted.</p>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button matDialogClose>Dismiss</button>
  </mat-dialog-actions>
</ng-template>
